<template>
  <BaseWidget
    class="accountant-subscription"
    :loading="loading"
    @refresh-data="refreshData"
    @set-config="setConfig"
    v-on="$listeners"
  >
    <template v-slot:header>
      <div class="title">
        <span class="title-icon"> </span>
        {{ $gettext('Your subscription') }}
      </div>
      <!-- <div class="description" v-translate>Manage your current plan and benefits</div> -->
    </template>
    
    <template v-slot:content>
      <div class="accountant-subscription-wrap">
        <section class="subscription-card accountant-subscription-wrap" aria-labelledby="sub-title">
          <header class="subscription-card__header">
            <!-- <div>
              <p class="subscription-card__subtitle">{{ $gettext('Manage your current plan and benefits') }}</p>
            </div> -->
            <div class="subscription-card__plan">
              <strong class="subscription-card__plan-name">{{ currentPlanName }}</strong>
            </div>
          </header>
          <dl class="subscription-card__details">
            <div class="subscription-card__row">
              <dt>{{ $gettext('Connections') }}</dt>
              <dd v-if="accountantConnectionTotals"><strong>{{ accountantConnectionTotals.in_use }}</strong><span class="muted"> / {{ maxConnections }}</span></dd>
            </div>
            <div class="subscription-card__row">
              <dt>{{ $gettext('Communications') }}</dt>
              <dd v-if="isActive">Full messaging</dd>
              <dd v-else>No messaging</dd>
            </div>
            <!-- <div class="subscription-card__row">
              <dt>{{ $gettext('Customer discount') }}</dt>
              <dd v-if="isActive">25%</dd>
              <dd v-else>0%</dd>
            </div> -->
            <div class="subscription-card__row">
              <dt>{{ $gettext('Referral fee') }}</dt>
              <dd v-if="isActive">€10</dd>
              <dd v-else>€0</dd>
            </div>
          </dl>
        </section>
      </div>
    </template>
    <template v-slot:actions>
      <footer class="subscription-card__actions">
        <GekkoButton 
          @click="$router.push({ name: 'AccountantSubscriptions' })"
          :text="$gettext('Upgrade plan')" 
        />
      </footer>
    </template>

  </BaseWidget>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseWidget from '@/components/dashboard/widgets/BaseWidget'
import GekkoButton from '@/components/GekkoButton';

export default {
  name: 'accountant-subscription-widget',
  components: {
    BaseWidget,
    GekkoButton
  },
  props: {
    widget: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: true,
      title: '',
      subtitle: '',
      config: { status: '' },
      filters: {},
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
      currentUser: 'main/getCurrentUser',
      isWaitingForResponse: 'main/isWaitingForResponse',
      activePlan: 'subscriptionStore/getActivePlan',
      billingSettings: 'subscriptionStore/getBillingSettings',
      getAvailableTiers: 'subscriptionStore/getAvailableTiers',
      accountantConnectionTotals: 'accountants/getAccountantConnectionTotals'
    }),
    currentPlanName () {
      return this.activePlan?.name || this.getAvailableTiers[0]?.name
    },
    isActive() {
      return this.activePlan?.status === 'active' || this.activePlan?.status === 'grace'
    },
    isGrace() {
      return this.activePlan?.grace_date !== null
    },
    isFree() {
      return Boolean(this.activePlan?.planline_set?.some(planLine => planLine.is_free))
    },
    isRenewalDisabled() {
      return !this.billingSettings.auto_renewal
    },
    isCancelled() {
      return this.billingSettings.cancelled || false
    },
    maxConnections () {
      return this.activePlan?.max_connections || this.getAvailableTiers[0]?.max_connections
    }
  },
  created() {

  },
  mounted() {
    this.setupWidget()
    this.setObjectStatus(this.widget.config)
  },
  methods: {
    ...mapActions({
      loadSubscriptionsMainData: 'subscriptionStore/loadSubscriptionsMainData',
    }),
    setConfig(config) {
      if (config.status) this.setObjectStatus(config)
      this.$emit('save-config', this.config)
    },
    setObjectStatus(config) {
      if (config.status) {
        this.config.status = config.status && config.status !== 'all' ? config.status : ''
      }
      this.setFilters()
    },
    setFilters(status = false) {
      this.filters.status = status ? (status === 'all' ? '' : status) : this.config.status
      this.refreshData()
    },
    refreshData() {
      this.getData()
    },
    updateFilters(status) {
      this.filters.status = status === 'all' ? '' : status
      this.setFilters(status)
    },
    getData() {
      this.loading = true
      this.loadSubscriptionsMainData().then(() => {
        this.loading = false
      })
    },
    setupWidget() {
      this.title = this.$gettext('Accountant subscription')
    },
    removeWidget() {
      this.$emit('widget-event', { event: 'remove' })
      setTimeout(() => {
        this.$emit('widget-event', { event: 'update', target: 'activities-timeline-widget' })
      }, 100)
    },
  },
}
</script>

<style lang="scss">
.widget-wrapper.accountant-subscription {
  cursor: pointer;
}

.accountant-subscription {
  width: 100%;

  .accountant-subscription-wrap {
    width: 100%;
  }
  .accountant-subscription-wrap.subscription-card {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .subscription-card__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
  }

  .subscription-card__subtitle {
    margin: 6px 0 0;
    font-size: 14px;
    line-height: 1.4;
    color: #667085;
  }

  .subscription-card__plan {
    flex-shrink: 0;
    min-width: 140px;
    width: 100%;
    // padding: 10px 14px;
    // border-radius: 12px;
    // background: #f8f9fc;
    text-align: center;
  }

  .subscription-card__plan-label {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    font-weight: 600;
    color: #667085;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .subscription-card__plan-name {
    display: block;
    font-size: 42px;
    font-weight: 700;
    color: #101828;
  }

  .subscription-card__details {
    margin: 0;
    padding: 0;
  }

  .subscription-card__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 0;
    border-top: 1px solid #f0f2f5;
  }

  .subscription-card__row:first-child {
    border-top: 0;
    padding-top: 0;
  }

  .subscription-card__row dt,
  .subscription-card__row dd {
    margin: 0;
  }

  .subscription-card__row dt {
    font-size: 14px;
    font-weight: 500;
    color: #475467;
  }

  .subscription-card__row dd {
    font-size: 14px;
    font-weight: 600;
    color: #101828;
    text-align: right;
  }

  .subscription-card__row .muted {
    color: #667085;
    font-weight: 500;
  }

  .subscription-card__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-top: 4px;
  }

  @media (max-width: 640px) {
    .subscription-card__header,
    .subscription-card__actions,
    .subscription-card__row {
      flex-direction: column;
      align-items: flex-start;
    }

    .subscription-card__plan,
    .subscription-card__row dd {
      text-align: left;
    }

    .subscription-card__plan {
      width: 100%;
    }

    .subscription-card__actions {
      width: 100%;
    }

    .subscription-card__cta {
      width: 100%;
    }
  }
}
</style>
